import React, { useState, useEffect } from 'react';
import { TextField, Select, MenuItem, Button, CircularProgress, Grid } from '@mui/material';
import axios from 'axios';

const OrdersFormPage = ({ orderId, history }) => {
  const [order, setOrder] = useState({
    newOperator: false,
    operatorName: '',
    operatorId: '',
    brandName: '',
    environment: '',
    marketCode: '',
    siteCode: '',
    serverId: '',
    lobbyName: '',
    gamingServerId: '',
    progressiveAccount: '',
    progressiveEmails: '',
    apiUrl: '',
    apiUsername: '',
    apiPassword: '',
    tokenTimeout: 0,
  });

  const [marketList, setMarketList] = useState([]);
  // const [siteList, setSiteList] = useState([]);
  // const [gamingSystemList, setGamingSystemList] = useState([]);
  // const [progressiveList, setProgressiveList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (orderId) {
      fetchOrder(orderId);
    }
    fetchMarketList();
  }, [orderId]);

  const fetchOrder = async (id) => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/Orders/${id}`);
      setOrder(data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const fetchMarketList = async () => {
    try {
      const { data } = await axios.get('/Config/Markets');
      setMarketList(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrder((prevOrder) => ({
      ...prevOrder,
      [name]: value,
    }));
  };

  const saveOrder = async () => {
    setLoading(true);
    try {
      if (orderId) {
        await axios.put(`/Orders/${orderId}`, order);
      } else {
        await axios.post('/Orders', order);
      }
      history.push('/orders');
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <div>
      <h2>{orderId ? 'Edit Order' : 'New Order'}</h2>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextField
            label="Operator Name"
            name="operatorName"
            value={order.operatorName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Brand Name"
            name="brandName"
            value={order.brandName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Select
            label="Environment"
            name="environment"
            value={order.environment}
            onChange={handleChange}
            fullWidth
          >
            <MenuItem value="UAT">UAT</MenuItem>
            <MenuItem value="Production">Production</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={6}>
          <Select
            label="Market"
            name="marketCode"
            value={order.marketCode}
            onChange={handleChange}
            fullWidth
          >
            {marketList.map((market) => (
              <MenuItem key={market.code} value={market.code}>
                {market.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        {/* Add other fields similarly */}
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={saveOrder}>
            Save Order
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrdersFormPage;


